import { CaretLeft } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Link } from 'theSource/components';

export const HomeLink = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const homePageUrl = `/`;

  const handleBackButton = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault(); // Prevent the default behavior of the link

    navigate(homePageUrl); // Use navigate to change the route
  };

  return (
    <Link
      internal
      value={t('back')}
      underline={false}
      IconComponent={CaretLeft}
      testId="back-button"
      onClick={handleBackButton}
    />
  );
};
